// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-box[data-v-3f0f73c8] {\n  border-width: 7px !important;\n}", ""]);
// Exports
module.exports = exports;
